var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// ./~/async-validator/~/core-js/library/modules/_html.js
// module id = 8a0X
// module chunks = 11